import { useContext, useEffect, useState } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import LastWorksCards from '../components/LastWorksCard';
import MyPartipationCard from '../components/MyPartipationCard';
import { loadJson } from '../utils/loadJson'; 

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';

const Home = () => {
    // const { language } = useContext(LanguageContext);
    var { language ,t} = useContext(LanguageContext);
    
    const [translations, setTranslations] = useState({});
    const [lastWorks, setLastWorks] = useState([]);
    const [myPartipations, setMyPartipations] = useState([]);

    useEffect(() => {
        // Cargar cada JSON de forma independiente y asignarlo a su variable
     
        const fetchTranslations = async () => {
            const data = await loadJson(`${process.env.PUBLIC_URL}/json/translations.json`);
            setTranslations(data);
        };

        const fetchLastWorks = async () => {
            const data = await loadJson(`${process.env.PUBLIC_URL}/json/LastWorks.json`);
            setLastWorks(data);
        };

        const fetchMyPartipations = async () => {
            const data = await loadJson(`${process.env.PUBLIC_URL}/json/myPartipations.json`);
            setMyPartipations(data);
        };

        fetchTranslations();
        fetchLastWorks();
        fetchMyPartipations();
    }, [language]);

    t = translations[language] || {};

    return (
        <div className="wrapper">
            <section className="sectionLang">
                <div id="title">
                    <div className="PanelLeft">
                        <div>
                            <h2 id="welcome-to-github-pages">{t.home?.title}</h2>
                        </div>
                    </div>
                    <div className="PanelRight">
                        <img src="img/ProfilePicture.png" alt="ProfileImage" />
                    </div>
                </div>
                <div className="PanelContent">
                    <div className="PanelLeft">
                        <div className="contentProfile">
                            <div>
                                {t.home?.description.map((text, index) => (
                                    <p key={index}>{text}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="PanelRight">
                  
              
                    
                    <div className="cardLastWorks">
                    
                        <p className="lastWorksTitle">
                            <a href={t.resume?.url}>
                                <b>{t.resume?.text}</b>
                            </a>
                            
                        </p>
                        <p className="lastWorksTitle">
                        <a href="https://github.com/mwest0101">
                        <b>GitHub</b> {t?.mygit}
                        </a>
                        </p>

                        </div>
                        {/* {console.log("Lenguaje : "+language)} */}
                        <b className="lastWorksTitle tohiden2">{t.home?.myParticipations}</b> 
                        <div className="myPartipationsContainer tohiden2">
                        <Swiper
                          modules={[Autoplay]}
                          spaceBetween={10}
                          slidesPerView={1}
                          autoplay={{ delay: 3000, disableOnInteraction: true }}
                          loop={true}
                          style={{ width: '250px' }}
                            className="swiperMyParticipations"

                        >
                          {myPartipations[language]?.map((works, index) => (
                            <SwiperSlide key={index} >
                              <MyPartipationCard works={works} index={index} />
                            </SwiperSlide>
                          ))}
                        </Swiper>
                        </div>

                    
                        <b className="lastWorksTitle tohiden2">{t.home?.lastWorks}</b>
                        <div>
                        {lastWorks[language]?.map((works, index) => (
                            <LastWorksCards key={index} works={works} index={index} />
                        ))}
                        </div>
                        </div>
                    </div>
               
                <li>
                    
                </li>
                <hr />
            </section>
        </div>
    );
};

export default Home;
